/**
 * @generated SignedSource<<8aaed03c7abe01a837ca6d7754632f8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIntegrationInput = {
  id: any;
};
export type PostgreSQLIntegrationsDialogDeleteMutation$variables = {
  input: DeleteIntegrationInput;
};
export type PostgreSQLIntegrationsDialogDeleteMutation$data = {
  readonly deleteIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type PostgreSQLIntegrationsDialogDeleteMutation = {
  response: PostgreSQLIntegrationsDialogDeleteMutation$data;
  variables: PostgreSQLIntegrationsDialogDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostgreSQLIntegrationsDialogDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostgreSQLIntegrationsDialogDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "832cc5f0d1d3d6736dd3ad14fdeb8581",
    "id": null,
    "metadata": {},
    "name": "PostgreSQLIntegrationsDialogDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PostgreSQLIntegrationsDialogDeleteMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "ade71e4a28f0859bb7765f2278a2a643";

export default node;
